import React, { memo } from 'react';

import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../AiChat.testIds';

import { containerStyles } from './ChatStatusMessage.styles';

const ChatStatusMessage = ({ title, description }) => (
  <Stack data-testid={AiChatTestIds.CHAT_STATUS_MESSAGE} sx={containerStyles}>
    <Typography color="text.secondary" variant="medium14">
      {title}
    </Typography>
    <Typography color="text.secondary" variant="regular14">
      {description}
    </Typography>
  </Stack>
);

ChatStatusMessage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default memo(ChatStatusMessage);
